import React, { useEffect } from 'react';
import './vision.css'

function Vision() {
	const revealSpans = () => {
		const spans = document.querySelectorAll('.opct');
		spans.forEach((span) => {
			const { left, top } = span.getBoundingClientRect();
			const adjustedTop = top - window.innerHeight * 0.65;
			let opacityValue = 1 - (adjustedTop * 0.01 + left * 0.001);
			opacityValue = Math.max(.01, opacityValue.toFixed(3));
			opacityValue = Math.min(1, opacityValue);
			span.style.opacity = opacityValue;
		});
	};

	useEffect(() => {
		const paragraphs = document.querySelectorAll('.content');

		paragraphs.forEach((paragraph) => {
			let htmlString = '';

			// Loop through each character, including ones inside existing span elements
			paragraph.childNodes.forEach((node) => {
				if (node.nodeType === 3) { // Text node
					const textArray = node.textContent.split('');
					textArray.forEach(char => {
						htmlString += `<span class="opct">${char}</span>`;
					});
				} else if (node.nodeType === 1 && node.tagName === 'SPAN') { // Existing span
					htmlString += `<span class="opct ${node.className}">${node.textContent}</span>`;
				}
			});
			paragraph.innerHTML = htmlString;
		});

		revealSpans();
		window.addEventListener('scroll', revealSpans);
		return () => {
			window.removeEventListener('scroll', revealSpans);
		};
	}, []);

	return (
		<div className='vision'>
			<p className="content">
				Inspired by <span className="pixel">Pixels</span>, driven by passion,
			</p>
			<p className="content">
				I <span className="text-neon font-bold">&lt; </span>code<span className="text-neon font-bold"> /&gt;</span> not just for function, but for the future,
			</p>
			<p className="content">
				sculpting tomorrow's possibilities with <span className="text-neon font-bold">&lt; </span>code<span className="text-neon font-bold"> /&gt;</span> and creativity.
			</p>
			<p className="content responsiveContent">
				Inspired by <span className="pixel">Pixels</span>, driven by passion, I <span className="text-neon font-bold">&lt; </span>code<span className="text-neon font-bold"> /&gt;</span> not just for function, but for the future, sculpting tomorrow's possibilities with <span className="text-neon font-bold">&lt; </span>code<span className="text-neon font-bold"> /&gt;</span> and creativity.
			</p>
		</div>
	)
}

export default Vision